import React, { Component } from 'react';
import './styles/Tutorial.css';

export default class Tutorial extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }

  handleModalClose = (e) => {
    e.preventDefault();
    document.getElementById('tutorial-modal').style.display = 'none';
  }

  render() {
    return (
      <div className='modal-wrapper1' id='tutorial-modal'>
        <div className='tut-modal-content'>
          <span id='tutorial-modal-closebtn' onClick={this.handleModalClose}>&#10006;</span>
          <h1 id='tutorial-modal-header'><b>Getting Started</b></h1> <br/>
          <h3><b>Select A Country</b></h3> <br/>
            <h4>
              Click on a country to get more information on that country's active cases, deaths, and recovered counts.
            </h4> <br/>
            <iframe src="https://giphy.com/embed/U3JEj8Xvrk9kjqvYMM" frameBorder="0"></iframe><p></p></div>
      </div>
    )
  }
}
